import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {ContactUsForm} from "../model/ContactUsForm";

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(private http: HttpClient) {

  }

  submitContactUsForm(dto: ContactUsForm): Observable<any> {
    return this.http.post(environment.apiUrl + "/feedbackSubmitAction", dto);
  }
}
